'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _mapKeys = require('lodash/mapKeys');

var _mapKeys2 = _interopRequireDefault(_mapKeys);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _compose = require('constructicon/lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

var _pages = require('../../api/pages');

var _me = require('../../api/me');

var _client = require('../../utils/client');

var _form = require('../../utils/form');

var _withGroups = require('./with-groups');

var _withGroups2 = _interopRequireDefault(_withGroups);

var _countries = require('../../utils/countries');

var _countries2 = _interopRequireDefault(_countries);

var _addressSearch = require('../address-search');

var _addressSearch2 = _interopRequireDefault(_addressSearch);

var _charitySearch = require('../charity-search');

var _charitySearch2 = _interopRequireDefault(_charitySearch);

var _charitySelect = require('../charity-select');

var _charitySelect2 = _interopRequireDefault(_charitySelect);

var _form2 = require('constructicon/form');

var _form3 = _interopRequireDefault(_form2);

var _grid = require('constructicon/grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridColumn = require('constructicon/grid-column');

var _gridColumn2 = _interopRequireDefault(_gridColumn);

var _inputField = require('constructicon/input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSelect = require('constructicon/input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

var _inputSlug = require('../input-slug');

var _inputSlug2 = _interopRequireDefault(_inputSlug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePageForm = function (_Component) {
  _inherits(CreatePageForm, _Component);

  function CreatePageForm() {
    _classCallCheck(this, CreatePageForm);

    var _this = _possibleConstructorReturn(this, (CreatePageForm.__proto__ || Object.getPrototypeOf(CreatePageForm)).call(this));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleAddressLookup = _this.handleAddressLookup.bind(_this);
    _this.state = {
      manualAddress: false,
      status: 'empty',
      errors: [],
      slugAvailable: false
    };
    return _this;
  }

  _createClass(CreatePageForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          authType = _props.authType,
          campaignId = _props.campaignId,
          charityFunded = _props.charityFunded,
          charityId = _props.charityId,
          eventId = _props.eventId,
          form = _props.form,
          onSuccess = _props.onSuccess,
          token = _props.token;


      return form.submit().then(function (data) {
        if (form.fields.slug && !_this2.state.slugAvailable) {
          return;
        }

        _this2.setState({
          errors: [],
          status: 'fetching'
        });

        var groupFields = (0, _pickBy2.default)(data, function (value, key) {
          return (/^group_values_/.test(key)
          );
        });
        var addressFields = (0, _pick2.default)(data, ['streetAddress', 'extendedAddress', 'locality', 'region', 'postCode', 'country', 'charityId']);

        var dataPayload = (0, _merge2.default)({
          authType: authType,
          campaignId: campaignId,
          charityFunded: charityFunded,
          charityId: charityId,
          charityOptIn: true,
          eventId: eventId,
          token: token,
          groupValues: (0, _mapKeys2.default)(groupFields, function (value, key) {
            return key.replace('group_values_', '');
          })
        }, data);

        return Promise.resolve().then(function () {
          return _this2.handleSubmitAddress(token, addressFields);
        }).then(function () {
          return _this2.handleSubmitPhone(token, data.phone);
        }).then(function () {
          return (0, _pages.createPage)(dataPayload);
        }).then(function (result) {
          _this2.setState({ status: 'fetched' });
          return onSuccess(result, dataPayload);
        }).catch(function (error) {
          switch (error.status) {
            case 422:
              var errors = (0, _get2.default)(error, 'data.error.errors') || [];

              return _this2.setState({
                status: 'failed',
                errors: errors.map(function (_ref) {
                  var field = _ref.field,
                      message = _ref.message;
                  return {
                    message: [(0, _capitalize2.default)(field.split('_').join(' ')), message].join(' ')
                  };
                })
              });
            case 400:
              var errorMessages = error.data || [];

              return _this2.setState({
                status: 'failed',
                errors: errorMessages.map(function (_ref2) {
                  var desc = _ref2.desc;
                  return {
                    message: (0, _capitalize2.default)(desc)
                  };
                })
              });
            default:
              var message = (0, _get2.default)(error, 'data.error.message') || (0, _get2.default)(error, 'data.errorMessage') || 'There was an unexpected error';

              return _this2.setState({
                status: 'failed',
                errors: message ? [{ message: message }] : []
              });
          }
        });
      });
    }
  }, {
    key: 'handleSubmitAddress',
    value: function handleSubmitAddress(token, address) {
      var _props2 = this.props,
          authType = _props2.authType,
          includeAddress = _props2.includeAddress;


      return includeAddress ? (0, _me.updateCurrentUser)({ authType: authType, token: token, address: address }) : Promise.resolve();
    }
  }, {
    key: 'handleSubmitPhone',
    value: function handleSubmitPhone(token, phone) {
      var _props3 = this.props,
          authType = _props3.authType,
          includePhone = _props3.includePhone;


      return !(0, _client.isJustGiving)() && includePhone ? (0, _me.updateCurrentUser)({ authType: authType, token: token, phone: phone }) : Promise.resolve();
    }
  }, {
    key: 'handleAddressLookup',
    value: function handleAddressLookup(address) {
      this.props.form.updateValues(address);
      this.setState({ manualAddress: true });
    }
  }, {
    key: 'getAutoRenderedFields',
    value: function getAutoRenderedFields(fields) {
      return (0, _form.renderFormFields)(fields, ['streetAddress', 'extendedAddress', 'locality', 'region', 'postCode', 'country']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          campaignId = _props4.campaignId,
          disableInvalidForm = _props4.disableInvalidForm,
          form = _props4.form,
          formComponent = _props4.formComponent,
          includeAddress = _props4.includeAddress,
          inputField = _props4.inputField,
          submit = _props4.submit;
      var _state = this.state,
          status = _state.status,
          errors = _state.errors;


      return _react2.default.createElement(
        _form3.default,
        _extends({
          errors: errors,
          isDisabled: disableInvalidForm && form.invalid,
          isLoading: status === 'fetching',
          noValidate: true,
          onSubmit: this.handleSubmit,
          submit: submit,
          autoComplete: 'off'
        }, formComponent),
        this.getAutoRenderedFields(form.fields).map(function (field) {
          switch (field.name) {
            case 'slug':
              return _react2.default.createElement(_inputSlug2.default, _extends({
                key: field.name
              }, field, inputField, {
                handleFetch: function handleFetch(slugAvailable) {
                  return _this3.setState({ slugAvailable: slugAvailable });
                }
              }));
            case 'charityId':
              return field.type === 'search' ? _react2.default.createElement(_charitySearch2.default, {
                key: field.name,
                campaign: campaignId,
                onChange: function onChange(charity) {
                  return field.onChange(charity.id);
                },
                inputProps: _extends({}, field, inputField)
              }) : _react2.default.createElement(_charitySelect2.default, {
                key: field.name,
                campaign: campaignId,
                inputProps: _extends({}, field, inputField)
              });
            default:
              var Tag = (0, _form.renderInput)(field.type);
              return _react2.default.createElement(Tag, _extends({ key: field.name }, field, inputField));
          }
        }),
        includeAddress && this.renderAddress()
      );
    }
  }, {
    key: 'renderAddress',
    value: function renderAddress() {
      var _this4 = this;

      var manualAddress = this.state.manualAddress;
      var _props5 = this.props,
          form = _props5.form,
          inputField = _props5.inputField,
          country = _props5.country;


      if (!manualAddress) {
        return _react2.default.createElement(_addressSearch2.default, {
          country: country,
          error: form.fields.streetAddress.error,
          onCancel: function onCancel() {
            return _this4.setState({ manualAddress: true });
          },
          onChange: this.handleAddressLookup,
          inputProps: inputField,
          required: true,
          validations: form.fields.streetAddress.validations
        });
      }

      return _react2.default.createElement(
        _grid2.default,
        { spacing: { x: 0.5 } },
        _react2.default.createElement(
          _gridColumn2.default,
          null,
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.streetAddress, inputField))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          null,
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.extendedAddress, inputField))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          null,
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.locality, inputField))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          { md: country ? 6 : 4 },
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.region, inputField))
        ),
        !country && _react2.default.createElement(
          _gridColumn2.default,
          { md: 4 },
          _react2.default.createElement(_inputSelect2.default, _extends({}, form.fields.country, inputField))
        ),
        _react2.default.createElement(
          _gridColumn2.default,
          { md: country ? 6 : 4 },
          _react2.default.createElement(_inputField2.default, _extends({}, form.fields.postCode, inputField))
        )
      );
    }
  }]);

  return CreatePageForm;
}(_react.Component);

CreatePageForm.propTypes = {
  /**
   * The campaignId for a valid campaign (EDH only - required)
   */
  campaignId: _propTypes2.default.string,

  /**
   * The charityId for a valid charity (Required for JG)
   */
  charityId: _propTypes2.default.string,

  /**
   * Whether Gift Aid is enabled
   */
  charityFunded: _propTypes2.default.bool,

  /**
   * Country for new page
   */
  country: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * Disable form submission when invalid
   */
  disableInvalidForm: _propTypes2.default.bool,

  /**
   * The eventId for a valid event (JG only - required)
   */
  eventId: _propTypes2.default.string,

  /**
   * Form fields to be passed to withForm config
   */
  fields: _propTypes2.default.object,

  /**
   * Props to be passed to the Form component
   */
  formComponent: _propTypes2.default.object,

  /**
   * Props to be passed to the InputField components
   */
  inputField: _propTypes2.default.object,

  /**
   * The onSuccess event handler
   */
  onSuccess: _propTypes2.default.func.isRequired,

  /**
   * The label for the form submit button
   */
  submit: _propTypes2.default.string,

  /**
   * The logged in users' auth token
   */
  token: _propTypes2.default.string.isRequired,

  /**
   * Include a charity search field - can be either "search" or "select" (defaults to search)
   */
  includeCharitySearch: _propTypes2.default.oneOf([_propTypes2.default.bool, 'search', 'select']),

  /**
   * Include phone in page creation
   */
  includePhone: _propTypes2.default.bool,

  /**
   * Include address search in the page creation
   */
  includeAddress: _propTypes2.default.bool
};

CreatePageForm.defaultProps = {
  authType: 'Basic',
  charityFunded: false,
  disableInvalidForm: false,
  fields: {},
  submit: 'Create Page'
};

var form = function form(props) {
  var includePhone = !(0, _client.isJustGiving)() && props.includePhone;

  var defaultFields = (0, _client.isJustGiving)() ? {
    title: {
      label: 'Page title',
      type: 'text',
      order: 1,
      required: true,
      maxLength: 255,
      placeholder: 'Title of your fundraising page',
      validators: [validators.required('Please enter a page title')]
    },
    slug: {
      label: 'Page URL',
      type: 'text',
      order: 2,
      required: true,
      maxLength: 255,
      placeholder: 'URL for your fundraising page',
      onKeyDown: function onKeyDown(e) {
        return e.which === 32 && e.preventDefault();
      },
      validators: [validators.required('Please enter your page URL'), validators.slug('Please enter a valid URL using only letters, numbers or hyphens (-)')]
    }
  } : {
    birthday: {
      label: 'Date of birth',
      type: 'date',
      order: 1,
      required: true,
      placeholder: 'DD/MM/YYYY',
      min: '1900-01-01',
      pattern: '[0-9]{4}-[0-9]{2}-[0-9]{2}',
      validators: [validators.required('Please enter your date of birth')]
    }
  };

  var optionalFields = _extends({}, includePhone && {
    phone: {
      label: 'Phone Number',
      type: 'tel',
      order: 2,
      required: true,
      validators: [validators.required('Please enter your phone number')]
    }
  }, props.includeCharitySearch && {
    charityId: {
      label: 'Charity',
      type: typeof props.includeCharitySearch === 'string' ? props.includeCharitySearch : 'search',
      order: 2,
      required: true,
      validators: [validators.required('Please select your charity')]
    }
  }, props.includeAddress && {
    country: {
      label: 'Country',
      initial: props.country,
      options: _countries2.default,
      required: true,
      validators: [validators.required('Please select a country')]
    },
    streetAddress: {
      label: 'Street Address',
      required: true,
      validators: [validators.required('Please enter a street address')]
    },
    extendedAddress: {},
    locality: {
      label: 'Town/Suburb',
      required: true,
      validators: [validators.required('Please enter a town/suburb')]
    },
    region: {
      label: 'State',
      required: true,
      validators: [validators.required('Please enter a state')]
    },
    postCode: {
      label: 'Post Code',
      required: true,
      validators: [validators.required('Please enter a post code')]
    }
  });

  return {
    fields: (0, _merge2.default)(defaultFields, optionalFields, props.fields)
  };
};

exports.default = (0, _compose2.default)(_withGroups2.default, (0, _withForm2.default)(form))(CreatePageForm);


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/create-page-form/index.js
// module id = 1343
// module chunks = 0